import ListShips from '../../containers/Ships/List';
import EntryShips from '../../containers/Ships';
import ListCruiseLines from '../../containers/CruiseLines/List';
import EntryCruiseLines from '../../containers/CruiseLines';

const cruiseLineShipRoutes = [
  {
    path: '/ships',
    exact: true,
    auth: true,
    component: ListShips,
  },
  {
    path: '/ships/:type',
    exact: true,
    auth: true,
    component: EntryShips,
  },
  {
    path: '/ships/:type/:id',
    exact: true,
    auth: true,
    component: EntryShips,
  },
  {
    path: '/cruise-lines',
    exact: true,
    auth: true,
    component: ListCruiseLines,
  },
  {
    path: '/cruise-lines/:type',
    exact: true,
    auth: true,
    component: EntryCruiseLines,
  },
  {
    path: '/cruise-lines/:type/:id',
    exact: true,
    auth: true,
    component: EntryCruiseLines,
  },
];

export default cruiseLineShipRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/cruiselines&ships.jsx